import React__default, { useState } from 'react';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends, createForOfIteratorHelperLoose as _createForOfIteratorHelperLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import ProductViewImage from './media.js';
import GalleryLightbox from './gallery-lightbox.js';

var _excluded = ["location", "alt", "gallery", "currentImage", "galleryPerRow", "CloseIcon"];
var sortGalleryByImage = function sortGalleryByImage(gallery, src) {
  var first = gallery[0];

  // Find image in gallery by src
  for (var _iterator = _createForOfIteratorHelperLoose(gallery), _step; !(_step = _iterator()).done;) {
    var i = _step.value;
    if (Object.values(i).some(function (x) {
      return x.x1 && x.x1.includes(src);
    })) {
      first = i;
      break;
    }
  }

  // Return new array with image first
  return [first].concat(gallery.filter(function (i) {
    return i !== first;
  }));
};
var ProductViewMedia = function ProductViewMedia(_ref) {
  var location = _ref.location,
    alt = _ref.alt,
    gallery = _ref.gallery,
    currentImage = _ref.currentImage,
    galleryPerRow = _ref.galleryPerRow,
    CloseIcon = _ref.CloseIcon,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var sortedGallery = React__default.useMemo(function () {
    return Array.isArray(gallery) && gallery.length > 1 ? sortGalleryByImage(gallery, currentImage.smallImage ? currentImage.smallImage.x2.split("/").pop() : "") : [];
  }, [currentImage, gallery]);
  var _useState = useState(false),
    lightboxOpen = _useState[0],
    setLightboxOpen = _useState[1];
  var _useState2 = useState(currentImage),
    lightboxImage = _useState2[0],
    setLightboxImage = _useState2[1];
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, currentImage.largeImage && /*#__PURE__*/React__default.createElement(GalleryLightbox, {
    CloseIcon: CloseIcon,
    gallery: sortedGallery,
    alt: alt,
    open: lightboxOpen,
    setOpen: setLightboxOpen,
    lightboxImage: lightboxImage,
    setLightboxImage: setLightboxImage
  }), /*#__PURE__*/React__default.createElement(ProductViewImage, _extends({}, props, {
    gallery: gallery ? sortedGallery : undefined,
    alt: alt,
    location: location,
    currentImage: currentImage,
    setLightboxImage: setLightboxImage,
    setOpen: setLightboxOpen,
    galleryPerRow: galleryPerRow
  })));
};

export { ProductViewMedia };
//# sourceMappingURL=index.js.map
